module.exports = __webpack_public_path__ + "static/media/loading.407d1252.gif";